import { partition } from "../../lib/iterable";

export function partitionNames(className: string | null | undefined, rx: RegExp) {
  if(!className) return ["", ""];
  return partition(className.match(/\S+/g) || [], (v)=>rx.test(v))
    .map(names=>names.join(" "));
}